import {
  GET_COMMENTS_LIST,
  GET_AUDIT_LIST,
  POST_COMMENT,
  GET_SUB_STAGE_DETAILS,
  POST_SUB_STAGE_DETAILS,
  CLEAR_FLAGS,
} from './actions';
import { REQUEST, SUCCESS } from 'utils/actionGenerator';
import _get from 'lodash/get';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_COMMENTS_LIST[REQUEST]:
      return { ...state, commentsList: [] };
    case GET_COMMENTS_LIST[SUCCESS]:
      return {
        ...state,
        commentsList: action.response.data,
      };

    case CLEAR_FLAGS:
      return {
        ...state,
        commentPosted: false,
        subStatusUpdated: false,
      };

    case GET_SUB_STAGE_DETAILS[REQUEST]:
      return { ...state, subStatusDetails: {} };
    case GET_SUB_STAGE_DETAILS[SUCCESS]:
      return {
        ...state,
        subStatusDetails: action.response.data,
      };

    case POST_SUB_STAGE_DETAILS[REQUEST]:
      return { ...state, subStatusUpdated: false };
    case POST_SUB_STAGE_DETAILS[SUCCESS]:
      return {
        ...state,
        subStatusUpdated: true,
      };

    case GET_AUDIT_LIST[REQUEST]:
      return { ...state, auditList: [] };
    case GET_AUDIT_LIST[SUCCESS]:
      return {
        ...state,
        auditList: action.response.stateDetails,
      };

    case POST_COMMENT[REQUEST]:
      return { ...state, commentPosted: false };
    case POST_COMMENT[SUCCESS]:
      return {
        ...state,
        commentPosted: true,
      };

    default:
      return state;
  }
}

export const getComments = (state) => _get(state, 'placement.activityTab.commentsList', []);
export const getSubStatusDetails = (state) => _get(state, 'placement.activityTab.subStatusDetails', {});
export const getSubStatusUpdatedFlag = (state) => _get(state, 'placement.activityTab.subStatusUpdated', {});
export const getAudit = (state) => _get(state, 'placement.activityTab.auditList', []);
export const getCommentPostFlag = (state) => _get(state, 'placement.activityTab.commentPosted', false);
